import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl, springBaseUrl } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/Footer";
import { Box, IconButton, Typography } from "@mui/material";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MainSkeleton from "../../skeletons/MainSkeleton";
import CheckinSkeleton from "../../skeletons/CheckinSkeleton";
import DigitalSignature from "./DigitalSignature";

const Registration = () => {
  const navigate = useNavigate();
  const hotelId = useSelector((state) => state?.HotelId);
  const HomepageData = useSelector((state) => state?.HomepageData);
  const SummaryData = useSelector((state) => state?.SummaryData);
  const currencySymbol = useSelector((state) => state?.Currency);
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);

  return (
    <>
      {loader ? (
        <CheckinSkeleton />
      ) : (
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <IconButton
              sx={{ backgroundColor: "#3D3D3D4D" }}
              onClick={() => {
                window.history.back();
              }}
            >
              <KeyboardArrowLeftIcon
                sx={{ color: "#FFFFFF", fontSize: 24, strokeWidth: 2 }}
              />
            </IconButton>
            <Typography
              sx={{ fontSize: 24, fontWeight: 900 }}
              color="text.gray"
            >
              Registration card
            </Typography>
          </Box>
          <Box sx={{ mt: 5 }}>
            <DigitalSignature />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Registration;
